export enum FEATURES {
  SOCIAL_WALL = 'social_wall',
}
